export default __webpack_public_path__ + "static/acadia-connect-icon-bfbc6ccd21c6a3e822f2ad95267aae4f.svg";